import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-7',
  templateUrl: './cards-7.component.html'
})
export class Cards7Component {



    }
